module.exports = __webpack_public_path__ + "assets/img/thanks-letter-2020_prize-1.2f1be176.png";